import React, { useState } from "react";
import LoadingOverlay from "react-loading-overlay";
import { Table, Input, DatePicker, Button, Form, Row, Col, Card } from "antd";

import useGetPhoneVerificationsSearch from "../../../../Hooks/queries/useGetPhoneVerificationsSearch";

const OtpLoginPasien = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [date, setDate] = useState("");

  const { data: responseData, isFetching: isLoading, error, refetch } = useGetPhoneVerificationsSearch({
    phone_number: phoneNumber,
    date: date,
    options: {
      enabled: false,
    }
  });

  const handleSearch = (e) => {
    e.preventDefault();
    if (phoneNumber && date) {
      refetch();
    }
  };

  const tableData = responseData?.phone_verifications || [];
  const errorMessage = error ? "Terjadi kesalahan saat mengambil data OTP." : null;

  const columns = [
    {
      title: "Nomor WhatsApp",
      dataIndex: "phone_number",
      align: "center",
    },
    {
      title: "Kode OTP",
      dataIndex: "verification_code",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (cell) => {
        return (
          <span>{cell === 'Verified' ? 'Terverifikasi' : cell === 'Not Verified' ? 'Belum Terverifikasi' : cell === 'Expired' ? 'Kedaluwarsa' : cell}</span>
        );
      }
    },
    {
      title: "Waktu Dibuat",
      dataIndex: "created_at",
      align: "center",
    }
  ];

  return (
    <>
      <LoadingOverlay active={isLoading} spinner text="Loading...">
        <div className="content-section">
          <div className="title-section">
            <h1 className="patient-page-title">OTP Login Pasien</h1>
            <h2 className="patient-page-subtitle">
              <span style={{ color: "#039BEB" }}>Master Data</span>
              <span style={{ color: "#00000029" }}> / OTP Login Pasien</span>
            </h2>
          </div>

          <Card className="shadow mb-4" bordered={false}>
            <Form layout="vertical" onFinish={() => handleSearch({ preventDefault: () => { } })}>
              <Row gutter={16} align="bottom">
                <Col xs={24} md={10}>
                  <Form.Item label="Nomor WhatsApp" style={{ marginBottom: 0 }}>
                    <Input
                      placeholder="Contoh: 62853..."
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      required
                      size="large"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={10}>
                  <Form.Item label="Tanggal" style={{ marginBottom: 0 }}>
                    <DatePicker
                      style={{ width: "100%" }}
                      onChange={(date, dateString) => setDate(dateString)}
                      format="YYYY-MM-DD"
                      required
                      size="large"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={4}>
                  <Form.Item style={{ marginBottom: 0 }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="w-100"
                      size="large"
                    >
                      Cari
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>

            <div style={{ marginTop: 24 }}>
              {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

              <div className="table-responsive">
                <Table
                  dataSource={tableData}
                  columns={columns}
                  rowKey="id"
                  pagination={{ pageSize: 10 }}
                  locale={{ emptyText: "Tidak ada data OTP ditemukan." }}
                />
              </div>
            </div>
          </Card>
        </div>
      </LoadingOverlay>
    </>
  );
};

export default OtpLoginPasien;
